import { formatNumber } from '@reverbdotcom/commons/src/money';
import { shippingPriceDataForMethod } from '@reverbdotcom/commons/src/components/listing_shipping_display';
import { core_apimessages_ShippingMethod as ShippingMethod } from '@reverbdotcom/commons/src/gql/graphql';

export function standardShippingPrice(listing, isSeller = false) {
  const standardShippingData = shippingPriceDataForMethod(listing, ShippingMethod.SHIPPED);
  if (isSeller && standardShippingData?.carrierCalculated) { return undefined; }
  if (!standardShippingData?.rate?.amount) { return undefined; }
  return formatNumber(Number(standardShippingData.rate.amount));
}

export function handleShippingMethodChange(dispatch, listing, method: ShippingMethod, isSeller = false) {
  dispatch({ type: 'setShippingMethod', value: method });
  if (method === ShippingMethod.LOCAL) {
    dispatch({ type: 'setShippingPrice', value: formatNumber(0) });
  } else if (method === ShippingMethod.SHIPPED) {
    dispatch({ type: 'setShippingPrice', value: standardShippingPrice(listing, isSeller) });
  }
}
